'use client';
import React from 'react';

export default function InPersonOnlineSection() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: '#E8D8D5', paddingTop: 'clamp(64px, 8vw, 112px)', paddingBottom: 'clamp(64px, 8vw, 112px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-24">

          {/* Left: heading */}
          <div style={{ flex: '0 0 auto', maxWidth: '360px' }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '16px',
              }}
            >
              Flexible Appointments
            </p>
            <h2
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(26px, 3vw, 44px)',
                fontWeight: '400',
                color: '#1A2332',
                lineHeight: '1.2',
              }}
            >
              In-Person and Online Consultations
            </h2>
          </div>

          {/* Right: body text */}
          <div style={{ flex: 1 }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: 'clamp(16px, 1.3vw, 19px)',
                color: '#4A4A4A',
                lineHeight: '1.8',
                marginBottom: '24px',
              }}
            >
              Appointments are offered both in person and via secure Zoom video consultation. Alongside in-person appointments in Wales, I also work with clients throughout the UK and Globally online. Many clients choose to combine in-person and online sessions, allowing therapy to remain consistent around professional commitments, family life, or travel.
            </p>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: 'clamp(16px, 1.3vw, 19px)',
                color: '#4A4A4A',
                lineHeight: '1.8',
              }}
            >
              Whichever format you choose, the focus remains on providing a confidential, attentive, and personalised therapeutic experience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
